module.exports = __webpack_public_path__ + "img/f72.67b227b0.jpg";